import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    contentHeaderCoin: {
        marginTop: 2,
        // flexDirection: 'row',
        // justifyContent: 'space-between',
        paddingHorizontal: 0,
    },
    contentDescriptionCoin: {
        flex: 1
    },
    contentHeaderCoin2:
    {
        marginTop: 30,
        marginBottom: 20,
        flexDirection: 'row',
        justifyContent: 'center',
        justifyContent: 'space-between',
        alignItems: "center",
        paddingHorizontal: 0
    },
    imgCoin: {
        width: 62,
        height: 62,
        borderRadius: 31,
        borderWidth: 2,
        borderColor: '#F49C16',
        alignSelf: "center",
    },
    nameCoin: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'right'
    },
    priceCoin: {
        marginTop: 5,
        fontWeight: 'bold',
        color: '#F49C16',
        fontSize: 16,
        textAlign: 'right'
    },
    titleCirculation: {
        fontSize: 14,
        fontWeight: 'bold',
    },
    amountCirculation: {
        fontSize: 14,
        marginTop: 5,
        fontWeight: '400',
    },
    imageContainer: {
        flex: 1,
        alignItems: 'center'
    },
    priceContainer: {
        flex: 1
    }
});

export default styles;
